import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined'

export const SupplierPartIcon = ImportContactsOutlinedIcon
export default SupplierPartIcon
